import { SocketConnectionStatus, useSocket } from "@/providers/SocketProvider"
import React, { useMemo } from "react"
import { cn } from "../../styles/utils"
import type { PropsWithClassname } from "../../types"
import { Icon } from "../Icons"
import { Tooltip } from "../Tooltip"

export type ConnectionStatusProps = PropsWithClassname

export const ConnectionStatus: React.FC<ConnectionStatusProps> = ({
  className,
}) => {
  const { connectionStatus } = useSocket()

  const { icon, tooltip, animationClass } = useMemo(() => {
    switch (connectionStatus) {
      case SocketConnectionStatus.CONNECTING:
      case SocketConnectionStatus.CONNECTED:
        return {
          icon: <Icon name="rotate-cw" className="h-6 w-6 text-warning-800" />,
          tooltip: "Connecting to server...",
          animationClass: "animate-spin",
        }
      case SocketConnectionStatus.REGISTERED:
        return {
          icon: (
            <Icon name="cloudCheck" className="h-6 w-6 text-typography-400" />
          ),
          tooltip: "Connected to server",
          animationClass: "",
        }
      case SocketConnectionStatus.DISCONNECTED:
      default:
        return {
          icon: <Icon name="cloud-off" className="h-6 w-6 text-error-500" />,
          tooltip: "Disconnected - Reconnecting automatically...",
          animationClass: "",
        }
    }
  }, [connectionStatus])

  const getStatusColor = () => {
    switch (connectionStatus) {
      case SocketConnectionStatus.CONNECTING:
        return "text-warning-500"
      case SocketConnectionStatus.CONNECTED:
      case SocketConnectionStatus.REGISTERED:
        return "text-success-500"
      case SocketConnectionStatus.DISCONNECTED:
      default:
        return "text-error-500"
    }
  }

  return (
    <Tooltip content={tooltip} placement="bottom">
      <div
        className={cn(
          "w-10 h-10 rounded-lg flex items-center justify-center",
          className,
        )}
      >
        <div className={cn(getStatusColor(), animationClass)}>{icon}</div>
      </div>
    </Tooltip>
  )
}
